import { Helmet } from "react-helmet";
import styles from "../../styles/pages/404.module.scss";
import { IconContext } from "react-icons";
import { FiCornerUpLeft } from "react-icons/fi";

export default function NotFound() {
	return (
		<>
			<Helmet>
				<title>404 | Responsible Recycling</title>
			</Helmet>
			<main className="clMainBg">
				<div className="container">
					<div className="row align-items-start justify-content-end">
						<div className="col-xxl-6 col-lg-8 col-md-10">
							<div className="clBox clError404Box">
								<div className={`pb-5 ${styles.Error404Wrap}`}>
									<h1>404</h1>
									<h4 className='mt-4'>Sorry, Page Not Found</h4>
									<p className='mb-5'>The page you have requested could not be found</p>
									<a href="/" className="btnWidth btn btn-green w-100 text-white">
										<IconContext.Provider value={{ size: "1.5em" }}>
											<FiCornerUpLeft /> Back to Home Page
										</IconContext.Provider>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</main>
		</>
	);
}